module.exports = __webpack_public_path__ + "static/media/basicKit__HCI.b7df9b2f.jpg";